
                            import workerSource from "./perspective-viewer.worker";
                            let cached = null;
                            export async function getWorkerURL() {
                                if (cached) return cached;
                                const blob = new Blob([workerSource], {
                                    type: "application/javascript",
                                });

                                cached = URL.createObjectURL(blob);
                                return cached;
                            }

                            function make_host(a, b) {
                                return {
                                    addEventListener(type, callback) {
                                        if (type === "message") {
                                            a.push(callback);
                                        }
                                    },
                                    removeEventListener(type, callback) {
                                        const idx = a.indexOf(callback);
                                        if (idx > -1) {
                                            a.splice(idx, 1);
                                        }
                                    },
                                    postMessage(msg, ports) {
                                        for (const listener of b) {
                                            listener({
                                                data: msg,
                                                ports: ports,
                                            });
                                        }
                                    },
                                    terminate() {},
                                    location: { href: "" },
                                };
                            }

                            function run_single_threaded() {
                                console.warn(
                                    "Running perspective in single-threaded mode"
                                );
                                const f = Function(
                                    "const self = arguments[0];" + workerSource
                                );
                                const workers = [];
                                const mains = [];
                                f(make_host(workers, mains));
                                return make_host(mains, workers);
                            }

                            export async function initialize(opts) {
                                const workerOpts = opts || {
                                    type: "module",
                                };
                                try {
                                    if (
                                        typeof window !== "undefined" &&
                                        window.location &&
                                        window.location.protocol &&
                                        window.location.protocol.startsWith(
                                            "file"
                                        )
                                    ) {
                                        console.warn(
                                            "file:// protocol does not reliably support Web Workers"
                                        );
                                        return run_single_threaded();
                                    }

                                    const url = await getWorkerURL();
                                    const worker = new Worker(url, workerOpts);
                                    return worker;
                                } catch (e) {
                                    console.error(
                                        "Error instantiating worker; falling back to single-threaded mode",
                                        e
                                    );
                                    return run_single_threaded();
                                }
                            }

                            export default getWorkerURL;
                        